import { isAxiosError } from 'axios';

interface ErrorResponse {
    error?: string;
    message?: string;
}

/**
 * Extracts the error message from an AxiosError for the UI display.
 *
 * @param {Error | null} error - Error object, usually an Axios error
 * @returns {string | null} Error message
 */
export const getErrorMessage = (error: Error | null): string | null => {
    if (!error) return null;
    if (isAxiosError(error)) {
        if (!error.response) {
            return error.code === 'ECONNABORTED'
                ? 'The request timed out. Please try again.'
                : 'Network error. Please check your connection.';
        }
        const data = error.response.data as ErrorResponse;
        const message = data?.error ?? data?.message;
        return typeof message === 'string' ? message : null;
    }
    return null;
};
